/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Sign_TitleInputs */



/**
* | output |
* | --- |
* | "Playtest NDA" |
*
* @param {Nda_Sign_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_sign_title = /** @type {((inputs?: Nda_Sign_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Sign_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("NDA de playtest")
	if (locale === "es") return /** @type {LocalizedString} */ ("NDA de playtest")
	if (locale === "pt") return /** @type {LocalizedString} */ ("NDA de playtest")
	if (locale === "it") return /** @type {LocalizedString} */ ("NDA di playtest")
	return /** @type {LocalizedString} */ ("Playtest NDA")
});